import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import { colors } from "../config/colors";

const ClearFilterButton = styled(Button)(({ theme, disabled }) => ({
  height: "36px",
  padding: "6px 12px",
  border: `1px solid #CED1D9`,
  borderRadius: "4px",
  backgroundColor: "#ffffff",
  color: disabled ? colors.nonActive : "#000000",
  fontSize: "14px",
  fontWeight: 500,
  textTransform: "none",
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: "#f5f5f7",
    borderColor: colors.primary,
    color: colors.primary,
  },
  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
}));

/**
 * ClearFilters Component - Reusable button for clearing all filters
 * @param {boolean} hasActiveFilters - Determines if the button should be enabled
 * @param {function} onClear - Callback function when clear button is clicked
 * @param {string} label - Optional custom button label (defaults to "Clear filters" or "Clear filter")
 */
export const ClearFilters = ({ hasActiveFilters = false, onClear, label }) => {
  const defaultLabel = hasActiveFilters ? "Clear filters" : "Clear filters";

  return (
    <ClearFilterButton
      disabled={!hasActiveFilters}
      onClick={onClear}
      variant="outlined"
    >
      {label || defaultLabel}
    </ClearFilterButton>
  );
};

export default ClearFilters;
